module.exports = __webpack_public_path__ + "img/thumb-p3.97bc3366.png";